module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_CYSTERNA_40.56e75766.svg";